import gql from 'graphql-tag';

const query = gql`
  query TrackerShoppingList($startDate: Date, $endDate: Date) {
    dailyTracker {
      shoppingList(startDate: $startDate, endDate: $endDate) {
        startDate
        endDate
        items {
          id
          productId
          name
          brand
          baseAmount
          baseUnit
          isBought
        }
      }
    }
  }
`;

export default query;
